export default __webpack_public_path__ + "scene2_2_icon2d81f5.png";